import HeroSection from "./components/HeroSection";
import ServicesGrid from "./components/ServicesGrid";
import WelcomeSection from "./components/WelcomeSection";

export default function Home() {
  return (
    <div className="flex flex-col">
      <HeroSection />
      <ServicesGrid />
      <WelcomeSection />
    </div>
  );
}